export const CAROUSEL_EVENTS = {
  SWIPE: 'carousel.swipe',
};
